import React from 'react'
import { Row, Col } from 'rsuite'

export default function AddressView({ data }) {
  const ShowData = ({ label, value }) => {
    return (
      <Col xs={24} sm={12} md={8} lg={8}>
        <span>
          &#9679; {`${label} : `}
          <b>{`${value || ''}`}</b>
        </span>
      </Col>
    )
  }

  return (
    <Row>
      {data?.urbanType && (
        <ShowData
          label={data.urbanType?.label}
          value={
            data.urbanType?.options.find((element) => element.value == data.urbanType.value)?.label
          }
        />
      )}

      {data?.addressName && (
        <ShowData label={data.addressName?.label} value={data.addressName?.value} />
      )}

      {data?.directorName && (
        <ShowData label={data.directorName?.label} value={data.directorName?.value} />
      )}

      {data?.buildingName && (
        <ShowData label={data.buildingName?.label} value={data.buildingName?.value} />
      )}

      {data?.roomNumber && (
        <ShowData label={data.roomNumber?.label} value={data.roomNumber?.value} />
      )}

      {data?.houseNumber && (
        <ShowData label={data.houseNumber?.label} value={data.houseNumber?.value} />
      )}

      {data?.villageNumber && (
        <ShowData label={data.villageNumber?.label} value={data.villageNumber?.value} />
      )}

      {data?.villageName && (
        <ShowData label={data.villageName?.label} value={data.villageName?.value} />
      )}

      {data?.lane && <ShowData label={data.lane?.label} value={data.lane?.value} />}

      {data?.road && <ShowData label={data.road?.label} value={data.road?.value} />}

      <ShowData label={'ตำบล/แขวง'} value={data?.location?.subDistrict} />

      <ShowData label={'อำเภอ/เขต'} value={data?.location?.district} />

      <ShowData label={'จังหวัด'} value={data?.location?.province} />

      <ShowData label={'รหัสไปรษณีย์'} value={data?.location?.zipCode} />
    </Row>
  )
}
